import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import {
  getRingCentralRingCentralCardData,
  getRingCentralBarData,
  getRingCentralCardData,
  setctype,
  setflag,
} from "./RingCentralSlice";
import { baseURL } from "../../../Util/axios_helper";
import { Button } from "../../../Util/common";
import { KendoGrid, RefreshKendoGrid } from "../../../Kendo/kendo_grid";

const RingCentralCard = (rtype, rfilter, rYear) => {
  const dispatch = useDispatch();
  const { RingCentralCardData } = useSelector((state) => state.ringcentral);
  const [IncomingCallCount, setIncomingCallCount] = useState(0);
  const [OutgoingCallCount, setOutgoingCallCount] = useState(0);
  const [MissedCallCount, setMissedCallCount] = useState(0);
  const [VoiceCallCount, setVoiceCallCount] = useState(0);
  const [IncomingMsgTextCount, setIncomingTextCount] = useState(0);
  const [OutgoingMsgCount, setOutgoingTextCount] = useState(0);
  const [flag, setflag] = useState(false);
  const [smsFlag, setsmsFlag] = useState(false);
  const [action, setaction] = useState("");
  const [filter, setfilter] = useState("");
  const [title, settitle] = useState("");
  const [exportFName, setexportFName] = useState("");
  const [refreshflag, setrefreshflag] = useState(0);
  const { selectedMonth, refresh, year, metrics } = useSelector(
    (state) => state.revenue
  );

  useEffect(() => {
    if (RingCentralCardData && RingCentralCardData != undefined) {
      let setValues =
        RingCentralCardData?.Records != undefined
          ? RingCentralCardData?.Records[0]
          : 0;
      setIncomingCallCount(setValues?.IncomingCall ?? 0);
      setOutgoingCallCount(
        (setValues?.OutgoingCall ?? 0) + (setValues?.HangUp ?? 0)
      );
      setMissedCallCount(setValues?.MissedCall ?? 0);
      setVoiceCallCount(setValues?.VoiceMail ?? 0);

      let vall =
        RingCentralCardData?.table2 != undefined
          ? RingCentralCardData?.table2[0]
          : 0;

      setIncomingTextCount(vall?.IncomingMessage ?? 0);
      setOutgoingTextCount(vall?.OutgoingMessage ?? 0);
    }
  }, [RingCentralCardData]);

  return (
    <>
      <div className="d-none"></div>
      <div className="col-md-1 Widget-hover" title="View Incoming Call Report">
        <a
          href={`#`}
          onClick={(e) => {
            var modal = document.getElementById("myModal");
            modal.style.display = "block";

            var span = document.getElementById("close");
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setflag(true);
            setsmsFlag(false);
            setaction("RingCentralCallLog_Report");
            setfilter("Accepted");
            setrefreshflag(refreshflag + 1);
            settitle("Incoming Call Report");
            setexportFName("Incoming_CallLog_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-phone-alt"></i>
              </span>
              <div className="dash-widget-info">
                <h3>{IncomingCallCount}</h3>
                <span> Incoming Calls</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div className="col-md-1 Widget-hover" title="View Outgoing Call Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setflag(true);
            setsmsFlag(false);
            setaction("RingCentralCallLog_Report");
            setfilter("Call Connected,Hang Up");
            settitle("Outgoing Call Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Outgoing_CallLog_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-phone-volume"></i>
              </span>
              <div className="dash-widget-info">
                <h3>{OutgoingCallCount}</h3>
                <span>Outgoing Call</span>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div className="col-md-1 Widget-hover" title="View Missed Call Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setflag(true);
            setsmsFlag(false);
            setaction("RingCentralCallLog_Report");
            setfilter("Missed");
            settitle("Missed Call Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Missed_CallLog_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-phone-slash"></i>
              </span>
              <div className="dash-widget-info">
                <h3>{MissedCallCount}</h3>
                <span> Missed Call</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div className="col-md-1 Widget-hover" title="View VoiceMail Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setflag(true);
            setsmsFlag(false);
            setaction("RingCentralCallLog_Report");
            setfilter("VoiceMail");
            settitle("Voice Mail Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Voice_Mail_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-voicemail"></i>
              </span>
              <div className="dash-widget-info">
                <h3>{VoiceCallCount}</h3>
                <span>Voice Mail</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div className="col-md-1 Widget-hover" title="View Incoming Text Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setflag(true);
            setsmsFlag(true);
            setaction("RingCentralSMSLog_Reports");
            setfilter("Inbound");
            settitle("Incoming Text Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Incoming_Text_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-inbox"></i>
              </span>
              <div className="dash-widget-info">
                <h3>{IncomingMsgTextCount}</h3>
                <span>Incoming Text</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div className="col-md-1 Widget-hover" title="View Outgoing Text Report">
        <a
          href={`#`}
          onClick={() => {
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
            var span = document.getElementsByClassName("close")[0];
            span.onclick = function () {
              modal.style.display = "none";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
              if (event.target == modal) {
                modal.style.display = "none";
              }
            };
            setflag(true);
            setsmsFlag(true);
            setaction("RingCentralSMSLog_Reports");
            setfilter("Outbound");
            settitle("Outgoing Text Report");
            setrefreshflag(refreshflag + 1);
            setexportFName("Outgoing_Text_Report");
          }}
        >
          <div className="card dash-widget">
            <div className="card-body">
              <span className="dash-widget-icon">
                <i class="las la-reply-all"></i>
              </span>
              <div className="dash-widget-info">
                <h3>{OutgoingMsgCount}</h3>
                <span>Outgoing Text</span>
              </div>
            </div>
          </div>
        </a>
      </div>
      {/* <!-- RingCentral Report Popup --> */}
      <div id="myModal" class="cmodal">
        <div class="cmodal-content">
          <div className="modal-header">
            <h5 className="modal-title-popup">{title}</h5>
            <span class="close" id="close">
              &times;
            </span>
          </div>
          <div className="row">
            <div className="col-md-12">
              {flag && !smsFlag && (
                <KendoGrid
                  exportFileName={exportFName}
                  name={"Rc_Report"}
                  paggable={true}
                  url={`${baseURL}Report/${action}?type=${metrics.type}&years=${year}&filter=${metrics.filter}&metrics=${filter}&value=${filter}`}
                  schema={{}}
                  refreshWhen={refreshflag}
                  columns={[
                    {
                      field: "Type",
                      title: "Type",
                      width: 90,
                    },
                    {
                      field: "FromPhoneNo",
                      title: "From Phone No",
                      width: 150,
                    },
                    {
                      field: "ToPhoneNo",
                      title: "To Phone No",
                      width: 150,
                    },
                    {
                      field: "FromName",
                      title: "From Name",
                      template: function (dataItem) {
                        return $("<div/>").html(dataItem.FromName).text();
                      },
                      width: 150,
                    },
                    {
                      field: "ToName",
                      title: "To Name",
                      template: function (dataItem) {
                        return $("<div/>").html(dataItem.ToName).text();
                      },
                      width: 150,
                    },
                    {
                      field: "Date",
                      title: "Call Date",
                      width: 110,
                    },
                    {
                      field: "Time",
                      title: "Call Time",
                      width: 110,
                    },
                    {
                      field: "Result",
                      title: "Result",
                      width: 100,
                    },
                    {
                      field: "DurationMs",
                      title: "Duration Min",
                      width: 120,
                    },
                  ]}
                  height={400}
                  showOptions={false}
                  showEdit={false}
                  showDelete={false}
                />
              )}
              {flag && smsFlag && (
                <KendoGrid
                  exportFileName={exportFName}
                  name={"Rc_sms_Report"}
                  url={`${baseURL}Report/${action}?type=${metrics.type}&years=${year}&filter=${metrics.filter}&metrics=${filter}&value=${filter}`}
                  schema={{}}
                  refreshWhen={refreshflag}
                  columns={[
                    {
                      field: "MessageStatus",
                      title: "Direction",
                      width: 100,
                    },
                    {
                      field: "Type",
                      title: "Type",
                      width: 100,
                    },
                    {
                      field: "FromNumber",
                      title: "From Number",
                      width: 140,
                    },
                    {
                      field: "ToNumber",
                      title: "To Number",
                      width: 140,
                    },
                    {
                      field: "FromName",
                      title: "From Name",
                      template: function (dataItem) {
                        return $("<div/>").html(dataItem.FromName).text();
                      },
                      width: 150,
                    },
                    // {
                    //   field: "ToName",
                    //   title: "To Name",
                    //   width: 150,
                    // },
                    {
                      field: "Date",
                      title: "Sms Date",
                      width: 110,
                    },
                    {
                      field: "Time",
                      title: "Sms Time",
                      width: 110,
                    },
                    {
                      field: "ReadStatus",
                      title: "Read Status",
                      width: 100,
                    },
                  ]}
                  showOptions={false}
                  showEdit={false}
                  showDelete={false}
                  paggable={true}
                  height={400}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End RingCentral Report Popup/ --> */}
    </>
  );
};

export default RingCentralCard;
